/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unescaped-entities */
// @ts-nocheck
import { useContext, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import InputForm from '@/components/atoms/input/InputForm'
import * as yup from "yup";
import { handleChangeField, handleChangeSelect } from '@/utility/helper/dataMutation';
import InputSearch from '@/components/atoms/input/inputSearch';
import { StyledButton } from '@/components';
import { CardAgenda, CardLatestNews, GeneralEmptyData, MetaData, PageLoading, Spinner } from '@/components/atoms';
import { background_list, icon_list } from '@/assets/images';
import useEvnetQuery from '@/utility/hooks/apiHooks/useEvents';
import dayjs from 'dayjs';
import route_list from '@/constant/routeUrl';
import Image from 'next/image';
import DataHandlerContext from '@/utility/context/dataHandler';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { getSeoMetadata } from '@/utility/apiProcess/seo/server';

// export const getServerSideProps = (async (context:any) => {
//   // Fetch data from external API
// 	// const serverBlogList = await getBlogListServer({page:1, limit: 10, order: 'desc', lang: context.req.cookies.language})
// 	// const serverFeaturedBlogList = await getFeaturedBlogListServer({page:1, limit: 10, order: 'desc', lang: context.req.cookies.language})
//   return { props: { 
//     ...(await serverSideTranslations(context.req.cookies.language, [
// 			'agenda',
// 			'footer', 
// 			'navbar',
// 		])) 
// 	}}
// })

export async function getStaticProps() {
  const locale = 'id'
  let seoMetadata = { data: { result: {} } }
  try {
    seoMetadata = await getSeoMetadata({category_slug: 'pages', names: 'events'})
  } catch (err) {
    console.error('[getStaticProps] getSeoMetadata failed at build time, falling back to {}', err)
  }

	return {
		props: {
      seoMetadata: seoMetadata.data.result || {},
			...(await serverSideTranslations(locale, ['footer', 'navbar', 'agenda'])),
		},
	}
}


const Press = (props) => {
  const {language, token, role, dataUser, dispatch}:any = useContext(DataHandlerContext)
	const { t } = useTranslation('agenda')
  const [currentLang, setCurrentLang] = useState(language)
	const lang = language
	const router = useRouter()
	const {loadingUpcomingEvents, loadingPastEvents, upcomingEventsData, startUpcomingEvents, startPastEvents, pastEventsData, setIsSearch, pastEventPageInfo } = useEvnetQuery()
  const [timer, setTimer] = useState<NodeJS.Timeout | number>(0)
  const [searchType, setSearchType] = useState("upcoming")
	const [formToState, setFormToState] = useState([
    {
      title: "",
      placeholder: 'Choose Status',
      type: 'select',
      value: '',
      name: 'keterangan',
      rules: yup.object().required("Influencer is required!").nullable(),
      error: '',
      options: [
        { value: 'Evaluasi', label: 'Evaluasi' },
        { value: 'Evaluasi 2', label: 'Evaluasi 2' },
        { value: 'Evaluasi 3', label: 'Evaluasi 3' }
      ],
    },
		{
      title: "",
      placeholder: 'Choose Status',
      type: 'select',
      value: '',
      name: 'keterangan2',
      rules: yup.object().required("Influencer is required!").nullable(),
      error: '',
      options: [
        { value: 'Evaluasi', label: 'Evaluasi' },
        { value: 'Evaluasi 2', label: 'Evaluasi 2' },
        { value: 'Evaluasi 3', label: 'Evaluasi 3' }
      ],
    },
		{
      title: "",
      placeholder: 'Search Upcoming Events',
      type: 'text',
      value: '',
      name: 'search',
      rules: yup.object().required("Influencer is required!").nullable(),
      error: '',
    },
  ])

	const [formToState2, setFormToState2] = useState([
		{
      title: "",
      placeholder: 'Search Past Events',
      type: 'text',
      value: '',
      name: 'search',
      rules: yup.object().required("Influencer is required!").nullable(),
      error: '',
    },
  ])

	const handleOnChange = (event:any, targetMutation:any, setTargetMutation:any) => {
    let clone_filter = _.cloneDeep(formToState)
    const targetType = event.target.type
    if(targetType === 'search') {
      clone_filter = handleChangeField(event, targetMutation)
    } else if(targetType === 'select') {
      clone_filter = handleChangeSelect(event, targetMutation)
    }
    setTargetMutation(clone_filter)
    
    clearTimeout(timer)
    const new_time = setTimeout(() => {
      handleFilter(clone_filter, 'filter_data')
    }, 2000)
    
    setTimer(new_time)
  }

  const handleFilter = (params:any = null, type:string) => {
		setIsSearch(true)
    let filter_data:any = {}
    // let clone_row_pagination = _.cloneDeep(rowsPagination)
    
    if(type === 'filter_data') {
      params.forEach((item:any) => {
        if(item.value) {
          if(_.isObject(item.value) && !_.isDate(item.value)) {
            filter_data[item.name] = item.value.value
          } else if(_.isDate(item.value)) {
            filter_data[item.name] = dayjs(item.value).format('YYYY-MM-DD')
          } else {
            filter_data[item.name] = item.value
          }
        }
      })

      filter_data = _.merge(filter_data)
    } else if(type === 'pagination') {
      _.cloneDeep(filterSearch).forEach((item:any) => {
        if(item.value) {
          filter_data[item.name] = item.value
        }
      })
      filter_data = _.merge(filter_data, params)
    } else {
      let clone_filter = _.cloneDeep(filterSearch)
      clone_filter = clone_filter.map((item:any) => {
        return {
          ...item,
          value: ''
        }
      })
      setFilterSearch(clone_filter)
    }

		if(searchType === "upcoming") {
			startUpcomingEvents({page: 1, limit: 99, lang: lang, ...filter_data})
		} else {
			startPastEvents({page: 1, limit: 10, lang: lang, ...filter_data})
		}
  }

	// useEffect(() => {
	// 	if(!_.isEmpty(currentLang)) {
	// 		if(lang !== currentLang) {
	// 			location.reload()
	// 		}
	// 	}
  // }, [lang])

	useEffect(() => {
    if(!_.isEmpty(language)) {
			setIsSearch(true)
			startUpcomingEvents({page: 1, limit: 5, lang: language})
			startPastEvents({page: 1, limit: 10, lang: language})
    }
  }, [language])


	if(loadingUpcomingEvents || loadingPastEvents) {
		return <PageLoading />
	}
	return (
		<div className='tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-w-full'>
      <MetaData title={props.seoMetadata.title} ogImage="https://i.ibb.co/bzC5z1g/socialbreadlogo.jpg" ogTitle={props.seoMetadata.title} keywords={props.seoMetadata.keywords} ogDescription={props.seoMetadata.description} />
			<div className='tw-newsroom-banner' id='newsroom-banner'>
				<div className='tw-m-auto md:tw-py-16 tw-py-8 tw-px-4 tw-max-w-6xl tw-mx-auto'>
					<h2 className='tw-text-white md:tw-text-5xl tw-text-2xl tw-font-bold tw-mb-5'>
						{t('agenda.title')}
					</h2>
					<span className='tw-text-white tw-text-sm tw-text-justify tw-flex'>
						{t('agenda.desc')}
					</span>
				</div>
			</div>
			<div className='tw-w-full tw-min-h-[500px] tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-[#F1F1F1] md:tw-rounded-[40px] tw-rounded-[20px]'>
				<div className='tw-newsroom-container tw-w-full'>
					<div className='tw-max-w-6xl tw-mx-auto md:tw-my-20 tw-my-10 md:px-0 tw-text-justify tw-px-4'>
						<h2 className="tw-mb-10 md:tw-text-5xl tw-text-3xl tw-font-bold tw-text-transparent md:tw-px-5 tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-30% tw-to-light-green tw-to-70% tw-text-left tw-w-fit tw-pb-1">{t('agenda.next_agenda')}</h2>
						{upcomingEventsData.length !== 0 ? (
							<div>
								<div className='tw-flex md:tw-flex-row tw-flex-col-reverse tw-mb-10 tw-gap-4 md:tw-px-5'>
									<div className='tw-grid tw-w-full'>
										{/* <InputForm 
											formData={formToState.slice(0, 2)}
											onChange={handleOnChange}
											targetMutation={formToState}
											setTargetMutation={setFormToState}
											containerStyle='tw-grid md:tw-grid-cols-2 tw-grid-cols tw-gap-4 md:tw-w-[400px]'
										/> */}
									</div>
									<div className='tw-flex tw-justify-end md:tw-w-[500px] md:mt-0'>
										<InputSearch value={formToState[2].value} name={formToState[2].name} placeholder={formToState[2].placeholder} onChange={e =>{
											setSearchType("upcoming")
											handleOnChange(e, formToState, setFormToState)
										}}/>
									</div>
								</div>
								<CardAgenda data={upcomingEventsData}/>
							</div>
						) : (
							<GeneralEmptyData />
						)}
						
						{/* <div className='tw-flex tw-flex-col tw-items-center tw-justify-center tw-my-9'>
							<h1 className='md:tw-text-4xl tw-text-2xl tw-font-bold tw-mb-10 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-text-left'>{t('agenda.dont_miss')}</h1>
							<div className='tw-flex md:tw-flex-row tw-flex-col tw-relative tw-gap-5 tw-w-full tw-justify-center'>
								<div className='md:tw-w-[400px] tw-w-full'>
									<InputSearch value={formToState[2].value} placeholder={formToState[2].placeholder}/>
								</div>
								<StyledButton
									title={'Subscribe →'}
									className='tw-text-white tw-z-[1] md:tw-ml-[-100px] btn-dark-to-light-green-gradient md:tw-text-md tw-text-xs tw-items-center md:tw-px-14 tw-px-10 md:tw-py-[5.5px] tw-py-3 tw-rounded-full tw-justify-center md:tw-flex'
									onClick={() => console.log('PUSH')}
								/>
							</div>
						</div> */}
						<div className='tw-max-w-6xl tw-mx-auto tw-my-8 md:px-0 tw-text-justify md:tw-px-4'>
							<h1 className='md:tw-text-6xl tw-text-2xl tw-font-bold tw-mb-10 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-pb-1'>{t('agenda.past_agenda')}</h1>
							{pastEventsData.length !== 0 ? (
								<div>
									<div className='tw-flex md:tw-flex-row tw-flex-col-reverse tw-mb-10 tw-gap-4'>
										<div className='tw-grid tw-w-full'>
											{/* <InputForm 
												formData={formToState.slice(0, 2)}
												onChange={handleOnChange}
												targetMutation={formToState}
												setTargetMutation={setFormToState}
												containerStyle='tw-grid md:tw-grid-cols-2 tw-grid-cols tw-gap-4 md:tw-w-[400px]'
											/> */}
										</div>
										<div className='tw-flex tw-justify-end md:tw-w-[500px] md:mt-0'>
											<InputSearch value={formToState2[0].value} name={formToState2[0].name} placeholder={formToState2[0].placeholder} onChange={e => {
												setSearchType("past")
												handleOnChange(e, formToState2, setFormToState2)
											}}/>
										</div>
									</div>
									{pastEventsData.map((item, index) => {
										return (
											<button key={`past-event-${index}`} className="tw-mb-6 tw-flex md:tw-flex-wrap tw-flex-wrap-reverse tw-bg-white tw-p-4 tw-rounded-xl tw-w-full" onClick={() => router.push(route_list.agendaDetail(item.id))}>
												<div className="tw-mb-0 tw-ml-auto tw-w-full tw-shrink-0 tw-grow-0 tw-basis-auto tw-px-3 md:tw-w-3/12">
													<div className="tw-relative tw-overflow-hidden tw-rounded-lg tw-bg-no-repeat tw-shadow-lg tw-shadow-black/20 tw-w-full tw-h-32">
														<img src={item.image} className="tw-w-full tw-h-full tw-object-cover" alt={item.title} />
													</div>
												</div>

												<div className="tw-mb-6 tw-mr-auto tw-w-full tw-shrink-0 tw-grow-0 tw-basis-auto tw-px-3 md:tw-mb-0 md:tw-w-9/12 tw-xl:w-7/12 tw-text-left">
													<p className="tw-text-neutral-500">
														<small>{dayjs(item.date).format("DD MMM")}</small>
													</p>
													<h5 className="tw-mb-3 tw-text-xl tw-font-bold tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green">{item.title}</h5>
													<div className='tw-flex tw-flex-row tw-justify-between tw-gap-8'>
														<p className="tw-text-neutral-500">
															{item.description}
														</p>
														<Image src={icon_list.next_gradient_green} alt="" />
													</div>
												</div>
											</button>
										)
									})}
								</div>
							) : (<GeneralEmptyData />)}
							
							{(pastEventPageInfo.totalPage > 1 && Number(pastEventPageInfo.currentPage) !== pastEventPageInfo.totalPage) &&  (
								<div className='tw-flex tw-items-center tw-justify-center tw-pt-2'>
									<div className='tw-bg-gradient-to-r tw-from-dark-green tw-from-30% tw-to-light-green tw-rounded-full tw-p-[1px]'>
										<StyledButton
											title={t('agenda.load_more')}
											className='tw-text-dark-green tw-bg-[#F1F1F1] tw-font-semibold md:tw-text-md tw-text-xs tw-items-center tw-px-5 md:tw-py-2 tw-py-3 tw-rounded-full  md:tw-flex md:tw-w-[200px] tw-justify-center'
											onClick={() => {
												setIsSearch(false)
			 									startPastEvents({page:Number(pastEventPageInfo.currentPage) + 1, limit: 10, order: 'desc', lang: lang})
					 						}} 
										/>
									</div>
								</div>
							)}
							
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Press

 